module.exports = __webpack_public_path__ + "img/cg7.01f5c18d.jpg";